/* eslint-disable */
import React, { useContext, useMemo, useState } from "react";

import { FormControl, OutlinedInput } from "@mui/material";
import { Grid, Paper, TextField, Button, Typography } from "@material-ui/core";
import { useHistory, Link, useParams } from "react-router-dom";
import {
  backgroundStyle,
  btnStyle,
  h2Style,
  inputStyle,
  logoStyle,
  paperStyle,
  pStyle,
} from "./styles";
import { AuthContext } from "../../contexts/authContext";
import { Header } from "components/Header/Header";
import { AuthPAGES } from "./pages";

const ChangePhone: React.FC<any> = () => {
  const history = useHistory();
  const authContext = useContext(AuthContext);
  const authFunctionalities = authContext.globalConfig?.authConfig;
  const [genericErrorMessage, setGenericErrorMessage] = useState("");
  const [phone, setPhone] = useState("");

  const theme = useMemo(() => {
    return authContext.globalConfig?.theme as unknown as undefined;
  }, [authContext]);

  const { email }: any = useParams();

  const onChangePhone = async (e: any) => {
    e.stopPropagation();
    if (phone) {
      try {
        const processPhone = phone.replace("|", "").replace(/\s/g, "");
        history.push(`${AuthPAGES.verifyPhone}/${phone}/${email}`);
        await authContext.onChangePhoneSubmitted(processPhone, email);
        
      } catch (e:any) {
        setGenericErrorMessage(e.message);
        console.log(e);
      }
    }
    history.push(`${AuthPAGES.verifyPhone}/${phone}`);
  };

  return (
    <>
      <Header showSettings={false} />
      <div style={backgroundStyle}>
        <Grid>
          <Paper elevation={0} style={paperStyle}>
            <div style={{ margin: "0px auto", width: "315px" }}>
              <Grid style={logoStyle}>
                <h2 style={h2Style}>Set up 2 Factor Authentication</h2>
                <p style={{ ...pStyle, fontSize: "14px" }}>
                  Please provide phone where to send verification code
                </p>
              </Grid>
              <FormControl sx={{ width: "25ch" }} variant="outlined">
                <OutlinedInput
                  error={genericErrorMessage != ""}
                  size="small"
                  style={{ ...inputStyle, marginTop: "0" }}
                  type="text"
                  value={phone}
                  onChange={(e: any) => setPhone(e.target.value)}
                  placeholder="Phone Number"
                />
              </FormControl>
            </div>
          </Paper>
          <Button
            type="submit"
            color="primary"
            variant="contained"
            style={btnStyle}
            onClick={(e) => {
              onChangePhone(e);
            }}
          >
            Continue
          </Button>
        </Grid>
      </div>
    </>
  );
};

export default ChangePhone;
